module.exports = __webpack_public_path__ + "static/depoimento 6-d4f8124870c7a63b439d1f631e0a8dae.svg";